import React from "react";
import { TenantContextInterface } from "./hooks/useTenantProvider";

export const TenantContext = React.createContext<TenantContextInterface>({
  isStateRequired: true,
  logoSmall: null,
  tenant: null,
});
